import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { fbaConversionFactors } from "./fbaConversionFactors";
import { Typography } from "@mui/material";

const useStyles = makeStyles({
  root: {
    background: 'transparent',
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    // padding: '10px',
    overflow: 'hidden',
    // margin: 10
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  },
  table: {
    overflow: 'auto',
    minHeight: '100px',
    height: 700,
    marginTop: 30,
    marginBottom: 20,
  },
});

export const FBASummaryDataTable = ({ fba, blur, darkMode, units }) => {

  try {
    // STYLES
    const classes = useStyles();
    if (!fba?.fbaData || fba?.fbaData?.length === 0) return (<></>);

    const globalUnits = units;
    const reservoirType = fba?.settings?.type?.value;

    const columns = [
      {
        field: 'date',
        headerName: 'Date',
        width: 175,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        type: 'string'
      },
      {
        field: 'days',
        headerName: 'Days',
        width: 75,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        // type: 'number'
      },
      {
        field: 'pwh',
        headerName: `Pwh (${globalUnits === 'metric' ? 'kPa' : 'psia'})`,
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'pwf',
        headerName: `Pwf (${globalUnits === 'metric' ? 'kPa' : 'psia'})`,
        width: 100,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'water',
        headerName: `Water Rate (${globalUnits === 'metric' ? 'm3/d' : 'stb/d'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'oil',
        headerName: `Oil Rate (${globalUnits === 'metric' ? 'm3/d' : 'stb/d'})`,
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'condensate',
        headerName: `Cond. Rate (${globalUnits === 'metric' ? 'm3/d' : 'stb/d'})`,
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'gas',
        headerName: `Gas Rate (${globalUnits === 'metric' ? 'E3m3/d' : 'mscf/d'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumWater',
        headerName: `Cum. Water (${globalUnits === 'metric' ? 'E3m3' : 'mstb'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumOil',
        headerName: `Cum. Oil (${globalUnits === 'metric' ? 'E3m3' : 'mstb'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumCondensate',
        headerName: `Cum. Cond. (${globalUnits === 'metric' ? 'E3m3' : 'mstb'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumGas',
        headerName: `Cum. Gas (${globalUnits === 'metric' ? 'E3m3' : 'mscf'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'salinity',
        headerName: 'Salinity (ppm)',
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'gor',
        headerName: `GOR (${globalUnits === 'metric' ? 'E3m3/m3' : 'scf/stb'})`,
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'owr',
        headerName: `OWR (${globalUnits === 'metric' ? 'm3/m3' : 'stb/stb'})`,
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cgr',
        headerName: `CGR (${globalUnits === 'metric' ? 'm3/E3m3' : 'stb/mscf'})`,
        width: 125,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'tmb',
        headerName: 'Tmb',
        width: 75,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'rnp',
        headerName: `RNP (${globalUnits === 'metric' ? 'kPa/m3/d' : 'psia/stb/d'})`,
        width: 75,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'rnpPrime',
        headerName: `RNP' (${globalUnits === 'metric' ? 'kPa/m3/d' : 'psia/stb/d'})`,
        width: 75,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qTransOR',
        headerName: `Frac. Water Rate (${globalUnits === 'metric' ? 'm3/d' : 'stb/d'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qOilFracture',
        headerName: `Frac. Oil Rate (${globalUnits === 'metric' ? 'm3/d' : 'stb/d'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qGasFracture',
        headerName: `Frac. Gas Rate (${globalUnits === 'metric' ? 'E3m3/d' : 'scf/d'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'qCondensateFracture',
        headerName: `Frac. Cond. Rate (${globalUnits === 'metric' ? 'm3/d' : 'stb/d'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumTransOR',
        headerName: `Frac. Cum. Water (${globalUnits === 'metric' ? 'm3' : 'stb'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumBblOilFracture',
        headerName: `Frac. Cum. Oil (${globalUnits === 'metric' ? 'm3' : 'stb'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumBblGasFracture',
        headerName: `Frac. Cum. Gas (${globalUnits === 'metric' ? 'E3m3' : 'scf'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      {
        field: 'cumCondensateFracture',
        headerName: `Frac. Cum. Cond. (${globalUnits === 'metric' ? 'm3' : 'stb'})`,
        width: 150,
        editable: false,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
      },
      
    ];

    let rows = [];

    fba?.fbaData?.forEach((value, index) => {
      rows.push({
        id: index,
        date: (new Date(value?.date)?.toLocaleDateString() + ' ' + (new Date(value?.date)?.toLocaleTimeString()) || 0),
        days: (value?.days)?.toFixed(4) || 0,
        pwh: (globalUnits === 'metric' ? value?.pwh * fbaConversionFactors.pwh : value?.pwh)?.toFixed(1) || 0,
        pwf: (globalUnits === 'metric' ? value?.pwf * fbaConversionFactors.pwf : value?.pwf)?.toFixed(1) || 0,
        water: (globalUnits === 'metric' ? value?.water * fbaConversionFactors.water : value?.water)?.toFixed(1) || 0,
        oil: (globalUnits === 'metric' ? value?.oil * fbaConversionFactors.oil : value?.oil)?.toFixed(1) || 0,
        gas: (globalUnits === 'metric' ? value?.gas * fbaConversionFactors.gas : value?.gas)?.toFixed(1) || 0,
        condensate: (globalUnits === 'metric' ? value?.condensate * fbaConversionFactors.condensate : value?.condensate)?.toFixed(1) || 0,
        cumWater: (globalUnits === 'metric' ? value?.cumWater * fbaConversionFactors.water : value?.cumWater)?.toFixed(1) || 0,
        cumOil: (globalUnits === 'metric' ? value?.cumOil * fbaConversionFactors.oil : value?.cumOil)?.toFixed(1) || 0,
        cumGas: (globalUnits === 'metric' ? value?.cumGas * fbaConversionFactors.gas : value?.cumGas)?.toFixed(1) || 0,
        cumCondensate: (globalUnits === 'metric' ? value?.cumCondensate * fbaConversionFactors.condensate : value?.cumCondensate)?.toFixed(1) || 0,
        salinity: (value?.salinity) || 0,
        gor: (globalUnits === 'metric' ? value?.gor * fbaConversionFactors.gor : value?.gor)?.toFixed(1) || 0,
        cgr: (globalUnits === 'metric' ? value?.cgr * fbaConversionFactors.cgr : value?.cgr)?.toFixed(1) || 0,
        owr: (value?.owr)?.toFixed(3) || 0, // does not require conversion (same units nominator and denominator)
        tmb: (fba?.diagnostics?.[index]?.tmb)?.toFixed(4) || 0,
        rnp: (globalUnits === 'metric' ? fba?.diagnostics?.[index]?.rnp * fbaConversionFactors.rnp : fba?.diagnostics?.[index]?.rnp)?.toFixed(4) || 0,
        rnpPrime: (globalUnits === 'metric' ? fba?.diagnostics?.[index]?.rnpPrime * fbaConversionFactors.rnp : fba?.diagnostics?.[index]?.rnpPrime)?.toFixed(4) || 0,
        qTransOR: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.qTransOR * fbaConversionFactors.water : fba?.historyMatch?.[index]?.qTransOR)?.toFixed(2) || 0,
        qOilFracture: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.qOilFracture * fbaConversionFactors.oil : fba?.historyMatch?.[index]?.qOilFracture)?.toFixed(2) || 0,
        qGasFracture: ((reservoirType === 1 ? fba?.historyMatch?.[index]?.qGasFracture : fba?.historyMatch?.[index]?.sepQGas) * (globalUnits === 'metric' ? fbaConversionFactors.gas : 1))?.toFixed(2) || 0,
        qCondensateFracture: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.qCondensateFracture * fbaConversionFactors.condensate : fba?.historyMatch?.[index]?.qCondensateFracture)?.toFixed(2) || 0,
        cumTransOR: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.cumTransOR * fbaConversionFactors.water : fba?.historyMatch?.[index]?.cumTransOR)?.toFixed(2) || 0,
        cumBblOilFracture: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.cumBblOilFracture * fbaConversionFactors.oil : fba?.historyMatch?.[index]?.cumBblOilFracture)?.toFixed(2) || 0,
        cumBblGasFracture: ((reservoirType === 1 ? fba?.historyMatch?.[index]?.cumBblGasFracture : fba?.historyMatch?.[index]?.cumSepGas) * (globalUnits === 'metric' ? fbaConversionFactors.gas : 1))?.toFixed(2) || 0,
        cumCondensateFracture: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.cumCondensate * fbaConversionFactors.condensate : fba?.historyMatch?.[index]?.cumCondensate)?.toFixed(2) || 0,
        // simulatorPbar: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.simulatorPbar * fbaConversionFactors.simulatorPbar : fba?.historyMatch?.[index]?.simulatorPbar)?.toFixed(1) || 0,
        simulatorSw: fba?.historyMatch?.[index]?.simulatorSw?.toFixed(4) || 0,
        gasPbarLinear: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.gasPbarLinear * fbaConversionFactors.gasPbarLinear : fba?.historyMatch?.[index]?.gasPbarLinear)?.toFixed(1) || 0,
        qGasLinear: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.qGasLinear * fbaConversionFactors.gas : fba?.historyMatch?.[index]?.qGasLinear)?.toFixed(2) || 0,
        qOilLinear: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.qOilLinear * fbaConversionFactors.oil : fba?.historyMatch?.[index]?.qOilLinear)?.toFixed(2) || 0,
        qWaterLinear: (globalUnits === 'metric' ? fba?.historyMatch?.[index]?.qWaterLinear * fbaConversionFactors.water : fba?.historyMatch?.[index]?.qWaterLinear)?.toFixed(2) || 0,
      });
    });

    return (
      <div className={classes.root} style={{position: 'relative', pointerEvents: blur && 'none'}}>
        
        {blur && <Typography style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', textAlign: 'center'}}>Please add FBA subscription to view and download full data</Typography>}
        <DataGrid
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[10,25,50,100]}
          disableSelectionOnClick
          className={classes.table}
          components={{
            Toolbar: GridToolbar,
          }}
          sx={{
            '& .MuiDataGrid-row:nth-of-type(odd)': {
              backgroundColor: darkMode ? 'grey' : 'whitesmoke'
            },
            '& .super-app-theme--Current': {
              fontWeight: 'bold',
              backgroundColor: 'rgba(7, 88, 183, 0.1)' // highlight the current row
            }
          }}
          style={{filter: blur && 'blur(5px)', fontSize: '12px'}}
          density="compact"
        />
      </div>
    );
  } catch (error) {
    return <></>
  };
};
